import { render, staticRenderFns } from "./Comunicados-Listagem.vue?vue&type=template&id=65b5252c&scoped=true&"
import script from "./Comunicados-Listagem.vue?vue&type=script&lang=js&"
export * from "./Comunicados-Listagem.vue?vue&type=script&lang=js&"
import style0 from "./Comunicados-Listagem.vue?vue&type=style&index=0&id=65b5252c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b5252c",
  null
  
)

component.options.__file = "Comunicados-Listagem.vue"
export default component.exports